/**
 * @file routes/_app/settings/organic-material-links.tsx
 * @description 有機資材查詢連結維護頁（2026-09-01 回報序4）。
 *
 * 此頁維護的連結會出現在「有機資材審查」模組頁與稽核任務內「有機資材審查」卡片的
 * 「常用允用資訊查詢連結」清單中。停用的連結不顯示；排序值越小越前。
 * 權限：讀 materials.read、寫 standards.manage（後端 /api/settings/organic-material-links 雙重把關）。
 */

import { createFileRoute } from '@tanstack/react-router';
import { Form, Input, Typography } from 'antd';
import { Link2 } from 'lucide-react';
import { LookupAdminPage } from '@/components/settings/LookupAdminPage';

/** TanStack Router 路由定義 */
export const Route = createFileRoute('/_app/settings/organic-material-links')({
  component: OrganicMaterialLinksPage,
});

/** 有機資材查詢連結維護頁（name + url） */
function OrganicMaterialLinksPage() {
  return (
    <LookupAdminPage
      resource="organic-material-links"
      resourceLabel="有機資材查詢連結"
      description="維護「有機資材審查」頁面提供給稽核員使用的外部查詢連結（如肥料管理整合資訊系統、農藥許可證查詢）。停用後不顯示，排序值越小越前。"
      nameMaxLength={100}
      metaIcon={<Link2 size={13} />}
      extraTableColumns={[
        {
          title: '連結網址',
          dataIndex: 'url',
          ellipsis: true,
          render: (v: string | undefined) =>
            v ? (
              <Typography.Link href={v} target="_blank" rel="noopener noreferrer">
                {v}
              </Typography.Link>
            ) : (
              '—'
            ),
        },
      ]}
      extraFormFields={
        <Form.Item
          name="url"
          label="連結網址"
          rules={[
            { required: true, message: '請輸入連結網址' },
            { type: 'url', message: '請輸入有效網址' },
            { pattern: /^https?:\/\//i, message: '網址須以 http:// 或 https:// 開頭' },
          ]}
        >
          <Input placeholder="https://" maxLength={2000} />
        </Form.Item>
      }
    />
  );
}
